import { BadgePercent, LifeBuoy, PhoneCall, Sparkles, ShieldCheck, Globe } from "lucide-react";
import { SpeakCta, ASSESSMENT_URL } from "../../Home/components/SpeakCta";

/* Copy from the v0 prototype (components/tnt-group/tnt-benefits.tsx, 2026-10-13), with its
   misspellings corrected ("Servcies", "cutomers") and stray double spaces removed. */
const BENEFITS = [
  {
    icon: BadgePercent,
    title: "14 days Free Promotion",
    description: "Plenty time to test drive Rentid with your first 14 days free on the Pro Plan. Most customers start renting the same day.",
  },
  {
    icon: LifeBuoy,
    title: "25% off Roadside & Tolls",
    description: "25% off the first month of Roadside and/or Tolls & Tickets when you sign up your fleet.",
  },
  {
    icon: PhoneCall,
    title: "Free Platform Onboarding",
    description: "Customized onboarding support call with a dedicated industry expert to help with questions at any time.",
  },
  {
    icon: Sparkles,
    title: "25% off Concierge Services",
    description: "Let our team do the heavy lifting with 25% off white-glove concierge onboarding services.",
  },
  {
    icon: ShieldCheck,
    title: "3 Free RentID credits",
    description: "Screen and verify renters with 3 complimentary RentID verification credits on us.",
  },
  {
    icon: Globe,
    title: "Free Rental Website or Embed Link",
    description: "Get your own branded direct-rental website. Already have a site? Use our customizable embed link.",
  },
];

/* Member benefits for the TNT Group partnership. Black section with frosted glass cards, each
   pairing an icon with the benefit copy. */
export function TntBenefits() {
  return (
    <section className="relative overflow-hidden rounded-t-[28px] md:rounded-t-[40px] bg-black pt-20 md:pt-28 pb-16 md:pb-20 text-white">
      {/* Red-coral gradient wash + ambient glow */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(120%_80%_at_50%_0%,rgba(244,63,94,0.28),rgba(251,113,133,0.12)_40%,transparent_70%)]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-32 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-rose-500/25 blur-[120px]"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:items-end">
          <div className="max-w-2xl">
            <span className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-sm font-medium text-white/80">
              Member Benefits
            </span>
            <h2 className="mt-5 font-heading text-3xl sm:text-4xl md:text-[44px] font-bold tracking-tighter leading-[1.05] text-balance">
              Exclusive perks for Turo Host Tips &amp; Tricks members.
            </h2>
          </div>
          <p className="text-base md:text-[20px] text-white/60 leading-relaxed text-pretty md:text-right">
            TNT Group members unlock preferred access, savings, and support for your direct rental business.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <div
                key={benefit.title}
                className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-md transition-colors hover:border-white/20 hover:bg-white/[0.09]"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/10">
                  <Icon className="h-6 w-6 text-white" aria-hidden="true" />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-white text-balance">{benefit.title}</h3>
                <p className="mt-2 text-sm text-white/60 leading-relaxed text-pretty">{benefit.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex justify-center">
          <SpeakCta href={ASSESSMENT_URL} label="Start for Free" />
        </div>
      </div>
    </section>
  );
}
